export const common = "https://app.madfunnels.com"